import Vue from 'vue'
import Router from 'vue-router'

// import { mapActions, mapGetters } from 'vuex'
// import store from '@/store'

// import Products from '@/views/Products.vue'
// import Categories from '@/views/Categories.vue'
// import Empty from '@/views/Empty.vue'

Vue.use(Router)

const createRouter = () => new Router({
    mode: 'history',
    scrollBehavior: (to, from) => {
        if (from?.path === to?.path) {
            return null;
        } else {
            // window.scrollTo(0, 0);
            return { x: 0, y: 0, behavior: 'smooth' };
        }
    },
    linkActiveClass: 'active',
    base: __dirname,
    routes: []
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router
